import { motion } from "framer-motion";
import { Phone, Mail, MapPin, Clock, ArrowUpRight } from "lucide-react";

export default function Contacts() {
  return (
    <section
      id="contacts"
      data-testid="contacts-section"
      className="section bg-white"
    >
      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end mb-14">
          <div className="lg:col-span-6">
            <div className="eyebrow mb-6">Контакты</div>
            <h2 className="font-display text-[#0A192F] text-3xl sm:text-4xl lg:text-5xl font-semibold leading-[1.1] tracking-tight">
              Свяжитесь с&nbsp;нами
            </h2>
          </div>
          <p className="lg:col-span-5 lg:col-start-8 text-slate-600 text-base lg:text-lg">
            Позвоните или напишите — обсудим задачу и подготовим предложение. Работаем с юридическими лицами и ИП.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <ContactCard
            href="tel:+79223829669"
            label="Телефон"
            value="+7 922 382-96-69"
            icon={Phone}
            testid="contact-phone"
          />
          <ContactCard
            href="mailto:bizoralogistikgroup@yandex.ru"
            label="Email"
            value="bizoralogistikgroup@yandex.ru"
            icon={Mail}
            testid="contact-email"
          />
          <InfoCard
            label="География"
            value="Поставки по всей России"
            icon={MapPin}
            testid="contact-geo"
          />
          <InfoCard
            label="Режим работы"
            value="Пн–Пт · рабочие часы"
            icon={Clock}
            testid="contact-hours"
          />
        </div>
      </div>
    </section>
  );
}

function ContactCard({ href, label, value, icon: Icon, testid }) {
  return (
    <motion.a
      href={href}
      data-testid={testid}
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.5 }}
      className="group bg-[#0A192F] hover:bg-[#122544] text-white p-8 lg:p-10 transition-colors flex items-start justify-between gap-6"
    >
      <div>
        <div className="w-12 h-12 bg-[#FF6B00] flex items-center justify-center mb-6">
          <Icon className="w-5 h-5 text-white" />
        </div>
        <div className="text-xs uppercase tracking-[0.2em] text-white/60 mb-2">
          {label}
        </div>
        <div className="font-display text-lg sm:text-2xl lg:text-3xl font-semibold break-all">
          {value}
        </div>
      </div>
      <ArrowUpRight className="w-6 h-6 text-white/60 group-hover:text-[#FF6B00] group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all" />
    </motion.a>
  );
}

function InfoCard({ label, value, icon: Icon, testid }) {
  return (
    <motion.div
      data-testid={testid}
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.5 }}
      className="bg-[#F8FAFC] border border-slate-200 p-8 lg:p-10"
    >
      <div className="w-12 h-12 bg-[#0A192F] flex items-center justify-center mb-6">
        <Icon className="w-5 h-5 text-white" />
      </div>
      <div className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-2">
        {label}
      </div>
      <div className="font-display text-lg sm:text-2xl lg:text-3xl font-semibold text-[#0A192F] break-words">
        {value}
      </div>
    </motion.div>
  );
}
